/**
 * Formats a numeric amount as a fixed-precision decimal string.
 * Normalizes intermediate values such as "17." to "17.00".
 */
export function formatDecimalAmount(
  amount: string | number,
  fractionDigits = 2,
): string {
  const raw = String(amount).trim();
  const value = Number(raw);

  if (!raw || !Number.isFinite(value)) {
    throw new TypeError(`"${raw}" is not a valid amount.`);
  }

  return value.toFixed(fractionDigits);
}
